import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    background: theme.warningBGColor,
    fontSize: theme.textFontSize,
    color: theme.warningTextColorDispatch,
    fontWeight: 500,
    marginTop: 8,
    display: 'inline-flex',
    padding: '12px',
    alignItems: 'flex-start',
    borderRadius: '4px',
    border: `1px solid ${theme.warningTextColorDispatch}`
  },
  loader: {
    clipPath: 'inset(0 3ch 0 0)',
    animation: 'l 1s steps(4) infinite'
  },
  '@keyframes l': {
    to: {
      clipPath: 'inset(0 -1ch 0 0)'
    }
  }
});

const DuplicatePickupStatus = ({ classes, children }) => {
  return (
    <div className={classes.container}>
      {children ? (
        children
      ) : (
        <>
          We are verifying if any potential duplicate pickups are present in the system
          <span className={classes.loader}>...</span>
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(DuplicatePickupStatus);
